module.exports = __webpack_public_path__ + "img/text-effect-outline.47865061.png";